<template>
  <Article :title="title" :subtitle="subtitle" :header="false">
    <Comparison>
      <template v-slot:title>
        <span class="t1">{{ $t('about_page.text_1')}}</span><span class="t2"> {{ $t('about_page.text_2')}}</span>
      </template>
      <template v-slot:subtitle>
        <p class="t4 text-center wow animated fadeIn" data-wow-duration="1s" data-wow-delay="0s">{{ $t('about_page.text_3')}}</p>
      </template>
      <template v-slot:comparison1>
        <div class="content-title">{{ $t('about_page.text_4')}}</div>
        <ul class="content-desc">
          <li>{{ $t('about_page.text_5')}}
          </li>
        </ul>
      </template>
      <template v-slot:comparison2>
        <div class="content-title">{{ $t('about_page.text_6')}}</div>
        <ul class="content-desc">
          <li>{{ $t('about_page.text_7')}}</li>
        </ul>
      </template>
      <template v-slot:comparison3>
        <div class="content-title">{{ $t('about_page.text_15')}}</div>
        <ul class="content-desc">
          <li>{{ $t('about_page.text_16')}}</li>
        </ul>
      </template>
    </Comparison>
    <TextImgLeft image="strategy.jpg" width="450px">
      <template v-slot:title>
        <h2 class="t1">{{ $t('about_page.text_8')}}</h2>
      </template>
      <template v-slot:subtitle>
        <p class="t4">{{ $t('about_page.text_9')}}</p>
        <p class="t4">{{ $t('about_page.text_10')}}</p>
      </template>
      <template v-slot:description>
        <ul>
          <li class="wow animated fadeIn" data-wow-duration="1s" data-wow-delay="0s">{{ $t('about_page.text_11')}}</li>
          <li class="wow animated fadeIn" data-wow-duration="1s" data-wow-delay="0s">{{ $t('about_page.text_12')}}</li>
          <li class="wow animated fadeIn" data-wow-duration="1s" data-wow-delay="0s">{{ $t('about_page.text_13')}}</li>
          <li class="wow animated fadeIn" data-wow-duration="1s" data-wow-delay="0s">{{ $t('about_page.text_14')}}</li>
        </ul>
      </template>
    </TextImgLeft>
    <section class="kc-elm kc-css-911125 kc_row">
      <div class="kc-row-container kc-container">
        <div class="kc-wrap-columns">
          <div class="kc-elm kc-css-225715 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
              <div class="kc_wrapper kc-col-inner-container">
                <div class="ssc_mltttl  kc-elm kc-css-958260 ">
                  <h2 class="wr deb derb dea dera none nonea"><span class="t1">{{ $t('about_page.text_17')}} </span></h2>
                </div>
                <div class="ssc_icon_box kc-elm kc-css-624171 template1 ">
                  <div class="icon_box">
                      <div class="bgr_no" style="width:35px; height:35px;">
                        <div> </div>
                      </div>
                      <div class="c_img" style="margin-top: -35px; line-height:35px; height:35px; width:35px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/what_big.png" alt="Big experience" style="max-width: 30px; max-height: 30px;margin-top: calc((35px - 30px)/2);" src="../../assets/images/what_big.png"></div>
                  </div>
                  <div class="cont_box">
                      <div class="title">{{ $t('about_page.text_18')}}</div>
                      <div class="description lines0">
                        <p>{{ $t('about_page.text_19')}}</p>
                      </div>
                  </div>
                </div>
                <div class="ssc_icon_box kc-elm kc-css-941434 template1 ">
                  <div class="icon_box">
                      <div class="bgr_no" style="width:35px; height:35px;">
                        <div> </div>
                      </div>
                      <div class="c_img" style="margin-top: -35px; line-height:35px; height:35px; width:35px;"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/what_strong.png" alt="Strong team" style="max-width: 30px; max-height: 30px;margin-top: calc((35px - 30px)/2);" src="../../assets/images/what_strong.png"></div>
                  </div>
                  <div class="cont_box">
                      <div class="title">{{ $t('about_page.text_20')}}</div>
                      <div class="description lines0">
                        <p>{{ $t('about_page.text_21')}}</p>
                      </div>
                  </div>
                </div>
                <div class="ssc_icon_box kc-elm kc-css-499767 template1 ">
                  <div class="icon_box">
                      <div class="bgr_no" style="width:35px; height:35px;">
                        <div> </div>
                      </div>
                      <div class="c_img" style="margin-top: -35px; line-height:35px; height:35px; width:35px;"><img class=" lazyloaded" data-src="../../assets/images/what_diff.png" alt="Personal solutions" style="max-width: 30px; max-height: 30px;margin-top: calc((35px - 30px)/2);" src="../../assets/images/what_diff.png"></div>
                  </div>
                  <div class="cont_box">
                      <div class="title">{{ $t('about_page.text_22')}}</div>
                      <div class="description lines0">
                        <p>{{ $t('about_page.text_23')}}</p>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    
  </Article>
  
</template>

<script>
import Article from "@/components/layout/Article";
import Comparison from "@/components/Blocks/Comparison";
import TextImgLeft from '@/components/Blocks/TextImgLeft';

export default {
  name: "AboutUs",
  components: {
    Article, Comparison, TextImgLeft
  },
  data() {
    return {
      title: "About us",
      subtitle: "GDPR"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.kc-css-911125{
  padding: 80px;
}
.ssc-subtitle {
  color: #ffffff;
}
p{
  text-align: justify;
}

@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-3{width:25%;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1425px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_row.kc_row_inner{width:calc(100% + 30px);}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
[class^="nat-"]{font-family:'native'!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.nat-cirleborder:before{content:"\ebd0";}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus,i:focus{outline:none;}
section{display:block;}
svg:not(:root){overflow:hidden;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
i{font-style:italic;}
*,*:before,*:after{box-sizing:inherit;}
.kc_row.kc_row_inner:focus{outline:none;}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
p{margin:10px 0 25px 0;line-height:26px;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.c_svg{display:table;z-index:2;position:relative;}
.c_svg div{display:table-cell;width:100%;vertical-align:middle;}
.c_svg svg{max-width:100%;max-height:100%;}
.ssc_icon_box.kc-elm{margin-bottom:10px;width:auto;}
.ssc_icon_box:after{content:"";display:block;clear:both;}
.ssc_icon_box i{transition:all 300ms ease-in;}
.ssc_icon_box,.ssc_icon_box .bgr_icon,.ssc_icon_box .bgr_icon i,.ssc_icon_box .icon_box,.ssc_icon_box .cont_box,.ssc_icon_box .title,.ssc_icon_box .cont_box .description,.ssc_icon_box .c_svg{transition:all 350ms ease-in;}
.ssc_icon_box.template3{text-align:center;}
.ssc_icon_box.template3 .title{margin-top:20px;}
.ssc_icon_box.template3 .bgr_icon i{margin:0 auto;}
.ssc_icon_box.template3 .c_svg{margin-left:auto;margin-right:auto;}
.ssc_icon_box.template3 .icon_box{width:100%;}
.ssc_icon_box .bgr_icon{position:relative;z-index:1;}
.ssc_icon_box .bgr_icon i{display:block;}
.ssc_icon_box .icon_box{width:10px;}
.ssc_icon_box .cont_box{vertical-align:top;}
.ssc_icon_box .title{margin-bottom:2px;font-size:20px;font-weight:700;}
.ssc_icon_box .cont_box .description{line-height:1.4em;}
.main [class*="lines"]{display:-webkit-box!important;-webkit-box-orient:vertical;overflow:hidden;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
@media screen and (max-width:480px){
.ssc_icon_box .bgr_icon i{margin-left:auto;margin-right:auto;}
.ssc_icon_box .icon_box{text-align:center;}
}
.ssc_mltttl .wr p{margin:0;}
.ssc_mltttl>div{display:block;width:auto;position:relative;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
p.t4{font-size:20px;line-height:26px;padding-top:20px!important;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1425px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-478371{width:100%;}
body.kc-css-system .kc-css-696606{width:25%;}
body.kc-css-system .kc-css-937967{width:25%;}
body.kc-css-system .kc-css-118172{width:25%;}
body.kc-css-system .kc-css-757130{width:25%;}
body.kc-css-system .kc-css-873504{width:25%;}
body.kc-css-system .kc-css-339992{width:25%;}
body.kc-css-system .kc-css-920217{width:25%;}
body.kc-css-system .kc-css-334574{width:25%;}
}
body.kc-css-system .kc-css-909007{padding-top:105px;padding-bottom:110px;}
body.kc-css-system .kc-css-731423.ssc_mltttl .wr{text-align:center;}
body.kc-css-system .kc-css-731423{text-align:center;margin-bottom:0px;padding-top:100px;padding-bottom:30px;display:inline-block;}
body.kc-css-system .kc-css-731423 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;margin-top:10px;margin-right:-5px;}
body.kc-css-system .kc-css-731423 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:25px;margin-right:-10px;}
body.kc-css-system .kc-css-731423 .t1{line-height:45px;margin-bottom:0px;display:inline;}
body.kc-css-system .kc-css-731423 .t2{color:#ED7D31;line-height:45px;display:inline;}
body.kc-css-system .kc-css-731423 .t4{margin-top:25px;padding-right:26%;padding-left:26%;}
body.kc-css-system .kc-css-93029{padding-top:20px;padding-bottom:20px;}
.kc-css-93029 >.kc_column_inner{padding-left:15px;padding-right:15px;}
body.kc-css-system .kc-css-1992{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-1992 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-1992 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-1992 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-1992 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-1992 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-1992 .icon_box{height:70px;}
body.kc-css-system .kc-css-1992 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-1992 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-1992 .c_svg div{height:30px;}
body.kc-css-system .kc-css-1992:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-314469{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-314469 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-314469 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-314469 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-314469 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-314469 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-314469 .icon_box{height:70px;}
body.kc-css-system .kc-css-314469 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-314469 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-314469 .c_svg div{height:30px;}
body.kc-css-system .kc-css-314469:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-296278{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-296278 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-296278 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-296278 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-296278 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-296278 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-296278 .icon_box{height:70px;}
body.kc-css-system .kc-css-296278 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-296278 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-296278 .c_svg div{height:30px;}
body.kc-css-system .kc-css-296278:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-942737{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-942737 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-942737 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-942737 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-942737 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-942737 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-942737 .icon_box{height:70px;}
body.kc-css-system .kc-css-942737 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-942737 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-942737 .c_svg div{height:30px;}
body.kc-css-system .kc-css-942737:hover .c_svg svg{fill:#ED7D31;}
.kc-css-34556 >.kc_column_inner{padding-left:15px;padding-right:15px;}
body.kc-css-system .kc-css-802933{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-802933 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-802933 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-802933 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-802933 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-802933 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-802933 .icon_box{height:70px;}
body.kc-css-system .kc-css-802933 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-802933 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-802933 .c_svg div{height:30px;}
body.kc-css-system .kc-css-802933:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-361435{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-361435 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-361435 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-361435 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-361435 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-361435 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-361435 .icon_box{height:70px;}
body.kc-css-system .kc-css-361435 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-361435 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-361435 .c_svg div{height:30px;}
body.kc-css-system .kc-css-361435:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-867326{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-867326 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-867326 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-867326 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-867326 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-867326 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-867326 .icon_box{height:70px;}
body.kc-css-system .kc-css-867326 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-867326 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-867326 .c_svg div{height:30px;}
body.kc-css-system .kc-css-867326:hover .c_svg svg{fill:#ED7D31;}
body.kc-css-system .kc-css-540748{width:300px;height: 380px;padding:33px 30px 27px 30px;border:1px solid #e4e7f2;border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-540748 .bgr_icon{color:#ED7D31;}
body.kc-css-system .kc-css-540748 .bgr_icon i{text-align:center;}
body.kc-css-system .kc-css-540748 .title{color:#222222;font-size:17px;line-height:25px;font-weight:500;text-transform:none;}
body.kc-css-system .kc-css-540748 .cont_box .description{color:#666666;font-size:17px;;margin-bottom:15px;}
body.kc-css-system .kc-css-540748 .cont_box .description{line-height:1.265em;}
body.kc-css-system .kc-css-540748 .icon_box{height:70px;}
body.kc-css-system .kc-css-540748 .c_svg{padding-top:calc((70px - 30px)/2);max-height:30px;width:30px;margin-top:-70px;}
body.kc-css-system .kc-css-540748 .c_svg svg{fill:#222222;}
body.kc-css-system .kc-css-540748 .c_svg div{height:30px;}
body.kc-css-system .kc-css-540748:hover .c_svg svg{fill:#ED7D31;}
@media only screen and (max-width:667px){
body.kc-css-system .kc-css-731423 .t4{padding-right:15px;padding-left:15px;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-478371{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-696606{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-1992{width:100%;}
body.kc-css-system .kc-css-937967{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-314469{width:100%;}
body.kc-css-system .kc-css-118172{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-296278{width:100%;}
body.kc-css-system .kc-css-757130{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-942737{width:100%;}
body.kc-css-system .kc-css-873504{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-802933{width:100%;}
body.kc-css-system .kc-css-339992{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-361435{width:100%;}
body.kc-css-system .kc-css-920217{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-867326{width:100%;}
body.kc-css-system .kc-css-334574{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-540748{width:100%;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-909007{padding-top:8px;padding-bottom:80px;}
}
/*! CSS Used fontfaces */
@font-face{font-display:swap;font-family:'native';src:url(../../assets/fonts/native.eot?3hn4ip);src:url('../../assets/fonts/native.eot?3hn4ip#iefix') format('embedded-opentype'),url(../../assets/fonts/native.ttf?3hn4ip) format('truetype'),url(../../assets/fonts/native.woff?3hn4ip) format('woff'),url('../../assets/fonts/native.svg?3hn4ip#native') format('svg');font-weight:400;font-style:normal;}

</style>



// WEBPACK FOOTER //
// src/components/Views/About.vue